import type { ModuleManifest } from '../types.js'

/**
 * Гарын авлага — хэрэглэгчид зориулсан баримтыг уншуулах модуль.
 *
 * ! Энэ модуль АГУУЛГАА ЭЗЭМШДЭГГҮЙ. Гарын авлага бүр нь `docs/manuals/<slug>/`
 * ! доторх markdown хавтас; API нь тэднийг дискнээс уншиж, бүтэц болгож өгнө.
 * ! Тиймээс шинэ гарын авлага нэмэхэд ЭНД ч, өөр хаана ч код засах шаардлагагүй —
 * ! хавтас үүсгэхэд л хангалттай. Дэлгэрэнгүйг `docs/14-manuals.md`.
 *
 * `docs/*.md` (хөгжүүлэгчийн баримт) ба `docs/manuals/` (хэрэглэгчийн гарын
 * авлага) хоёр нь ӨӨР зүйл: эхнийх нь кодыг, хоёр дахь нь панелийг тайлбарлана.
 */
export const docsModule = {
  key: 'docs',
  name: 'Гарын авлага',
  description: 'Модуль тус бүрийн хэрэглэгчийн гарын авлага. Агуулга нь repo дахь markdown файл.',
  version: '1.0.0',
  icon: 'BookOpenIcon',

  permissions: [
    { resource: 'docs.manuals', action: 'list', description: 'Гарын авлагууд жагсаах' },
    { resource: 'docs.manuals', action: 'show', description: 'Гарын авлага унших' },

    /*
     * БИЧИХ эрх. Жагсаах/унших эрхээс ТУСДАА: гарын авлага нь бүх ажилтанд
     * харагддаг ч агуулгыг нь цөөхөн хүн эзэмших ёстой — буруу засвар нь
     * заавар мөрдөж буй хүн бүрд тархана.
     */
    { resource: 'docs.manuals', action: 'manage', description: 'Гарын авлага бичих, засах, устгах' },
  ],

  navigation: [
    {
      label: 'Тусламж',
      items: [
        {
          label: 'Гарын авлага',
          href: '/docs',
          icon: 'BookOpenIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'docs.manuals:list',
        },
      ],
    },
  ],

  /*
   * `show` нь `/docs/:id` — уншигчийн эхний хуудас. Дотоод хуудсууд
   * (`/docs/hr/02-...`) нь Refine-ийн үйлдэл биш тул энд зарлагдахгүй.
   */
  resources: [
    {
      name: 'docs.manuals',
      label: 'Гарын авлага',
      list: '/docs',
      show: '/docs/:id',
    },
  ],
} as const satisfies ModuleManifest
